import { Injectable } from '@angular/core';
import {
  ConfirmationDialogDataType,
  defaultConfirmationDialogData,
} from '../types/confirmation-dialog-data.type';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';
import { DialogDisplayService } from 'studio-components/dialog/services/dialog-display.service';
import { Theme } from 'studio-components/shared/types/theme.type';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationDialogService {
  constructor(private dialog: DialogDisplayService) {}

  public open(data: Partial<ConfirmationDialogDataType>, theme: Theme = 'light') {
    const dialogOptions = { theme };

    const dialogData = {
      ...defaultConfirmationDialogData,
      ...data,
    };

    return this.dialog.open(ConfirmationDialogComponent, dialogOptions, dialogData);
  }
}
